export const profileImageChangedEvent = "stancekit:profile-image-changed";

export function notifyProfileImageChanged(): void {
  window.dispatchEvent(new Event(profileImageChangedEvent));
}
